/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type VehicleZoneViolationEvent,
    VehicleZoneViolationEventFromJSON,
    VehicleZoneViolationEventToJSON,
} from '../models/VehicleZoneViolationEvent';
import {
    type VehicleZoneViolationEventCreate,
    VehicleZoneViolationEventCreateFromJSON,
    VehicleZoneViolationEventCreateToJSON,
} from '../models/VehicleZoneViolationEventCreate';
import {
    type VehicleZoneViolationIncident,
    VehicleZoneViolationIncidentFromJSON,
    VehicleZoneViolationIncidentToJSON,
} from '../models/VehicleZoneViolationIncident';

export interface VehicleZoneViolationEventsCreateVehicleZoneViolationEventRequest {
    vehicleZoneViolationEventCreate: VehicleZoneViolationEventCreate;
}

export interface VehicleZoneViolationEventsReadVehicleZoneViolationEventRequest {
    id: string;
}

export interface VehicleZoneViolationEventsReadVehicleZoneViolationIncidentRequest {
    id: string;
}

/**
 * VehicleZoneViolationEventsApi - interface
 * 
 * @export
 * @interface VehicleZoneViolationEventsApiInterface
 */
export interface VehicleZoneViolationEventsApiInterface {
    /**
     * Creates request options for vehicleZoneViolationEventsCreateVehicleZoneViolationEvent without sending the request
     * @param {VehicleZoneViolationEventCreate} vehicleZoneViolationEventCreate 
     * @throws {RequiredError}
     * @memberof VehicleZoneViolationEventsApiInterface
     */
    vehicleZoneViolationEventsCreateVehicleZoneViolationEventRequestOpts(requestParameters: VehicleZoneViolationEventsCreateVehicleZoneViolationEventRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new vehicle to vehicle zone violation event
     * @summary Create a vehicle zone violation event
     * @param {VehicleZoneViolationEventCreate} vehicleZoneViolationEventCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleZoneViolationEventsApiInterface
     */
    vehicleZoneViolationEventsCreateVehicleZoneViolationEventRaw(requestParameters: VehicleZoneViolationEventsCreateVehicleZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleZoneViolationEvent>>;

    /**
     * Create a new vehicle to vehicle zone violation event
     * Create a vehicle zone violation event
     */
    vehicleZoneViolationEventsCreateVehicleZoneViolationEvent(requestParameters: VehicleZoneViolationEventsCreateVehicleZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleZoneViolationEvent>;

    /**
     * Creates request options for vehicleZoneViolationEventsReadVehicleZoneViolationEvent without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof VehicleZoneViolationEventsApiInterface
     */
    vehicleZoneViolationEventsReadVehicleZoneViolationEventRequestOpts(requestParameters: VehicleZoneViolationEventsReadVehicleZoneViolationEventRequest): Promise<runtime.RequestOpts>;

    /**
     * Retrieves a single vehicle zone violation event by ID
     * @summary Get vehicle zone violation event
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleZoneViolationEventsApiInterface
     */
    vehicleZoneViolationEventsReadVehicleZoneViolationEventRaw(requestParameters: VehicleZoneViolationEventsReadVehicleZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleZoneViolationEvent>>;

    /**
     * Retrieves a single vehicle zone violation event by ID
     * Get vehicle zone violation event
     */
    vehicleZoneViolationEventsReadVehicleZoneViolationEvent(requestParameters: VehicleZoneViolationEventsReadVehicleZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleZoneViolationEvent>;

    /**
     * Creates request options for vehicleZoneViolationEventsReadVehicleZoneViolationIncident without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof VehicleZoneViolationEventsApiInterface
     */
    vehicleZoneViolationEventsReadVehicleZoneViolationIncidentRequestOpts(requestParameters: VehicleZoneViolationEventsReadVehicleZoneViolationIncidentRequest): Promise<runtime.RequestOpts>;

    /**
     * Retrieve a single vehicle zone violation incident by ID.
     * @summary Read a vehicle zone violation incident
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleZoneViolationEventsApiInterface
     */
    vehicleZoneViolationEventsReadVehicleZoneViolationIncidentRaw(requestParameters: VehicleZoneViolationEventsReadVehicleZoneViolationIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleZoneViolationIncident>>;

    /**
     * Retrieve a single vehicle zone violation incident by ID.
     * Read a vehicle zone violation incident
     */
    vehicleZoneViolationEventsReadVehicleZoneViolationIncident(requestParameters: VehicleZoneViolationEventsReadVehicleZoneViolationIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleZoneViolationIncident>;

}

/**
 * 
 */
export class VehicleZoneViolationEventsApi extends runtime.BaseAPI implements VehicleZoneViolationEventsApiInterface {

    /**
     * Creates request options for vehicleZoneViolationEventsCreateVehicleZoneViolationEvent without sending the request
     */
    async vehicleZoneViolationEventsCreateVehicleZoneViolationEventRequestOpts(requestParameters: VehicleZoneViolationEventsCreateVehicleZoneViolationEventRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleZoneViolationEventCreate'] == null) {
            throw new runtime.RequiredError(
                'vehicleZoneViolationEventCreate',
                'Required parameter "vehicleZoneViolationEventCreate" was null or undefined when calling vehicleZoneViolationEventsCreateVehicleZoneViolationEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_zone_violation_events/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleZoneViolationEventCreateToJSON(requestParameters['vehicleZoneViolationEventCreate']),
        };
    }

    /**
     * Create a new vehicle to vehicle zone violation event
     * Create a vehicle zone violation event
     */
    async vehicleZoneViolationEventsCreateVehicleZoneViolationEventRaw(requestParameters: VehicleZoneViolationEventsCreateVehicleZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleZoneViolationEvent>> {
        const requestOptions = await this.vehicleZoneViolationEventsCreateVehicleZoneViolationEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleZoneViolationEventFromJSON(jsonValue));
    }

    /**
     * Create a new vehicle to vehicle zone violation event
     * Create a vehicle zone violation event
     */
    async vehicleZoneViolationEventsCreateVehicleZoneViolationEvent(requestParameters: VehicleZoneViolationEventsCreateVehicleZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleZoneViolationEvent> {
        const response = await this.vehicleZoneViolationEventsCreateVehicleZoneViolationEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleZoneViolationEventsReadVehicleZoneViolationEvent without sending the request
     */
    async vehicleZoneViolationEventsReadVehicleZoneViolationEventRequestOpts(requestParameters: VehicleZoneViolationEventsReadVehicleZoneViolationEventRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vehicleZoneViolationEventsReadVehicleZoneViolationEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_zone_violation_events/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieves a single vehicle zone violation event by ID
     * Get vehicle zone violation event
     */
    async vehicleZoneViolationEventsReadVehicleZoneViolationEventRaw(requestParameters: VehicleZoneViolationEventsReadVehicleZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleZoneViolationEvent>> {
        const requestOptions = await this.vehicleZoneViolationEventsReadVehicleZoneViolationEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleZoneViolationEventFromJSON(jsonValue));
    }

    /**
     * Retrieves a single vehicle zone violation event by ID
     * Get vehicle zone violation event
     */
    async vehicleZoneViolationEventsReadVehicleZoneViolationEvent(requestParameters: VehicleZoneViolationEventsReadVehicleZoneViolationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleZoneViolationEvent> {
        const response = await this.vehicleZoneViolationEventsReadVehicleZoneViolationEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleZoneViolationEventsReadVehicleZoneViolationIncident without sending the request
     */
    async vehicleZoneViolationEventsReadVehicleZoneViolationIncidentRequestOpts(requestParameters: VehicleZoneViolationEventsReadVehicleZoneViolationIncidentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling vehicleZoneViolationEventsReadVehicleZoneViolationIncident().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_zone_violation_events/incident/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve a single vehicle zone violation incident by ID.
     * Read a vehicle zone violation incident
     */
    async vehicleZoneViolationEventsReadVehicleZoneViolationIncidentRaw(requestParameters: VehicleZoneViolationEventsReadVehicleZoneViolationIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleZoneViolationIncident>> {
        const requestOptions = await this.vehicleZoneViolationEventsReadVehicleZoneViolationIncidentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleZoneViolationIncidentFromJSON(jsonValue));
    }

    /**
     * Retrieve a single vehicle zone violation incident by ID.
     * Read a vehicle zone violation incident
     */
    async vehicleZoneViolationEventsReadVehicleZoneViolationIncident(requestParameters: VehicleZoneViolationEventsReadVehicleZoneViolationIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleZoneViolationIncident> {
        const response = await this.vehicleZoneViolationEventsReadVehicleZoneViolationIncidentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
